<div class="upsell-product-box relative z-2">
  <div class="upsell-product-box__container justify-center mx-auto w-full p-4">
    <div class="upsell-product-box__wrapper">
      
      <div *ngIf="title" class="upsell-product-box__title bg-hartfelt-red text-center text-white cooper text-xl p-4 font-semibold"><div [innerHTML]="title"></div></div>
      
      <div class="upsell-product-box__content flex flex-col items-center desktop:flex-row gap-6 p-4 py-8 bg-white">
        <div class="upsell-product-box__image-wrapper w-full desktop:w-1/2 mx-auto flex flex-col justify-center desktop:flex-shrink-0">
          <img class="upsell-product-box__image max-h-80 self-center" src="{{ image }}" alt="{{ imageAlt }}">
        </div>

        <div class="upsell-product-box__description w-full desktop:w-1/2 text-center px-4">
          <p class="upsell-product-box_subtitle text-xl font-bold" [innerHTML]="subTitle"></p>
          <div class="upsell-product-box__pricing text-lg font-semibold placeholder:space-y-2">

            <div class="upsell-product-box__line w-64 mx-auto my-2 h-px bg-neutral-400"></div>

            <p class="upsell-product-box__regularPrice notranslate"> 
              <span class="upsell-product-box__regularPrice-text">{{regularText}}: </span> 
              <span class="upsell-product-box__regularPrice-number">{{ regularPrice | dynamicCurrency:currency }}</span>
            </p>
            <p class="upsell-product-box__instantSavings text-lg font-semi hartfelt-red notranslate">
              <span class="upsell-product-box__instantSavings-text">{{instantSavingsText}}: </span> 
              <span class="upsell-product-box__instantSavings-number">{{ instantSavings | dynamicCurrency:currency }}</span>
            </p>

            <div class="upsell-product-box__line w-64 mx-auto my-2 h-px bg-neutral-400"></div> 

            <p class="upsell-product-box__yourPrice text-xl font-bold text-green-700 notranslate"> 
              <span class="upsell-product-box__yourPrice-text">{{yourPriceText}}: </span>
              <span class="upsell-product-box__yourPrice-number">{{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
            </p>
          </div>

          <upsell-cta *ngIf="productBoxCTA"
            [buttonYesText]="buttonYesText"
            [buttonNoText]="buttonNoText"
            (eventEmitter)="nextPage($event)">
          </upsell-cta>
        </div>
      </div>
    </div>
  </div>
</div>
